export default {
  
    contratista: {
    }
}